import React, { useState } from "react";
import "./Navbar.css";

function NavIcon({ type }) {
  const commonProps = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  };

  const icons = {
    home: (
      <svg {...commonProps}>
        <path d="M3 10.5 12 3l9 7.5" />
        <path d="M5.5 9.5V20h13V9.5" />
        <path d="M10 20v-5h4v5" />
      </svg>
    ),
    students: (
      <svg {...commonProps}>
        <path d="M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
        <circle cx="9.5" cy="7" r="3.2" />
        <path d="M21 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M15.5 3.3a3.2 3.2 0 0 1 0 6.2" />
      </svg>
    ),
    teachers: (
      <svg {...commonProps}>
        <path d="m4 7 8-4 8 4-8 4-8-4Z" />
        <path d="M8 10.5v3.2c0 1.5 1.8 2.8 4 2.8s4-1.3 4-2.8v-3.2" />
        <path d="M20 9v5" />
        <circle cx="20" cy="16.5" r="1.2" />
      </svg>
    ),
    attendance: (
      <svg {...commonProps}>
        <rect x="4" y="5" width="16" height="15" rx="2" />
        <path d="M8 3v4M16 3v4M4 10h16" />
        <path d="m9 14 2 2 4-4" />
      </svg>
    ),
    finance: (
      <svg {...commonProps}>
        <path d="M12 2v20" />
        <path d="M17 6.5c0-1.7-2.2-3-5-3s-5 1.3-5 3 1.5 2.5 5 3 5 1.3 5 3-2.2 3-5 3-5-1.3-5-3" />
      </svg>
    ),
    reports: (
      <svg {...commonProps}>
        <path d="M7 3h7l5 5v13H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
        <path d="M14 3v5h5" />
        <path d="M10 13h6M10 17h6M10 9h1" />
      </svg>
    ),
    dashboard: (
      <svg {...commonProps}>
        <rect x="3" y="3" width="8" height="8" rx="2" />
        <rect x="13" y="3" width="8" height="5" rx="2" />
        <rect x="13" y="10" width="8" height="11" rx="2" />
        <rect x="3" y="13" width="8" height="8" rx="2" />
      </svg>
    ),
    inquiries: (
      <svg {...commonProps}>
        <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z" />
        <path d="M8 8h8M8 12h5" />
      </svg>
    ),
    salary: (
      <svg {...commonProps}>
        <rect x="3" y="6" width="18" height="12" rx="2" />
        <path d="M3 10h18" />
        <path d="M7 14h3M14 14h3" />
      </svg>
    )
  };

  return <span className="sidebar-nav__item-icon-svg">{icons[type] || icons.home}</span>;
}

function Navbar({ activeTab, setActiveTab, sidebarCollapsed, setSidebarCollapsed, adminSession, isMobileNav }) {
  const [openGroupKey, setOpenGroupKey] = useState(null);
  const canViewSalary = adminSession?.role === "admin";
  const navItems = [
    {
      key: "home",
      title: "Home",
      icon: "home"
    },
    {
      key: "students",
      title: "Students",
      icon: "students"
    },
    {
      key: "teachers",
      title: "Teachers",
      icon: "teachers"
    },
    {
      key: "attendance",
      title: "Attendance",
      icon: "attendance"
    },
    {
      key: "inquiries",
      title: "Inquiries",
      icon: "inquiries"
    },
    {
      key: "finance",
      title: "Finance",
      icon: "finance",
      children: [
        {
          key: "financeFees",
          title: "Student Fees"
        },
        ...(canViewSalary
          ? [
              {
                key: "financePay",
                title: "Teachers Pay"
              }
            ]
          : [])
      ]
    },
    {
      key: "dashboardHandle",
      title: "Dashboard Handle",
      icon: "dashboard",
      children: [
        {
          key: "galleryAdmin",
          title: "Gallery"
        },
        {
          key: "testMarksheet",
          title: "Test / Marksheet"
        },
        {
          key: "birthdayWishes",
          title: "Birthday Wishes"
        }
      ]
    },
    {
      key: "reports",
      title: "Reports",
      icon: "reports"
    }
  ];

  return (
    <nav className={`sidebar-nav ${sidebarCollapsed ? "sidebar-nav--collapsed" : ""}`}>
      <div className="sidebar-nav__brand">
        <img src="/rita-tech-logo.png" alt="Rita Tech" className="sidebar-nav__brand-banner" />
        <div className="sidebar-nav__brand-title">Rita Tech</div>
      </div>

      <div className="sidebar-nav__section">
        {/* <p className="sidebar-nav__label">Modules</p> */}
        {navItems.map((item) => (
          (() => {
            const hasActiveChild = item.children?.some((child) => child.key === activeTab);
            const isGroupOpen = openGroupKey === item.key || hasActiveChild;
            return (
          <div
            key={item.key}
            className={`sidebar-nav__group ${item.children ? "sidebar-nav__group--has-children" : ""} ${
              isGroupOpen ? "sidebar-nav__group--open" : ""
            }`}
          >
            <button
              className={`sidebar-nav__item ${
                activeTab === item.key || item.children?.some((child) => child.key === activeTab) ? "active" : ""
              }`}
              onClick={() => {
                if (item.children?.length) {
                  setOpenGroupKey((current) => (current === item.key ? null : item.key));
                  return;
                }
                setActiveTab(item.key);
              }}
            >
              <span className="sidebar-nav__item-icon"><NavIcon type={item.icon} /></span>
              <span className="sidebar-nav__item-title">{item.title}</span>
            </button>

            {item.children?.length ? (
              <div className="sidebar-nav__submenu">
                {item.children.map((child) => (
                  <button
                    key={child.key}
                    className={`sidebar-nav__submenu-item ${activeTab === child.key ? "active" : ""}`}
                    onClick={() => {
                      setOpenGroupKey(null);
                      setActiveTab(child.key);
                    }}
                  >
                    {child.title}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
            );
          })()
        ))}
      </div>
    </nav>
  );
}

export default Navbar;
